module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    attrs: {
      "id": "sidebar"
    }
  }, [_c('task-bar'), _c('dialer'), _c('comment-global-modal')], 1), _c('task-modal-form', {
    attrs: {
      "id": "dialer-manual-task-form-modal"
    }
  }), _c('list-composers'), _c('tag-picker-modal', {
    ref: "tag_picker_modal",
    attrs: {
      "taggable": _vm.contact,
      "prop_id": _vm.tag_picker_id
    },
    on: {
      "picked": _vm.addTagsToContact
    }
  }), _c('confirm-modal', {
    attrs: {
      "id": "global_confirm_modal",
      "title": "Excluir comentário",
      "message": "Deseja realmente excluir este comentário?",
      "confirm_text": "Sim, excluir",
      "confirm_class": "btn-danger"
    },
    on: {
      "confirm-modal-confirm": _vm.confirmRemoveComment
    }
  }), _c('reset-contact-modal')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-547811aa!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/shared/global_boxes.vue
// module id = 1123
// module chunks = 1